import React, {useEffect, useRef, useState} from "react";
import "./summary.scss";
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import {sendTestData} from "../../store/actions/examActions";
import {useParams} from "react-router";
import {useDispatch, useSelector} from "react-redux";
import {sendToNetwork, updateExamError} from "../../store/slices/examSlice";
import parse from "html-react-parser";
import {LoadingGallery} from "../../components/loading";
import {getRandomSeconds} from "../../api/urls";

export const SummaryPage = () => {
  const {id} = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {testdata} = useSelector((state) => state.exam);
  const finalQuestions = useSelector((state) => state.exam.finalQuestions);
  const [isSuccess,setIsSuccess] = useState(false);
  const [isStartLoad,setIsStartLoad] = useState(false);
  const timeout = useRef("");
  const [searchParams] = useSearchParams();
  const isTime =  searchParams.get("submit");
  useEffect(() => {
    if(isTime) {
      startLoad();
    }
    else{
      dispatch(sendToNetwork(id));
    }
  }, [id]);

  useEffect(() => {
    if(testdata.startSending){
      dispatch(sendTestData({uniqueId:id,...finalQuestions}));
    }
  },[testdata.startSending,isSuccess])

  useEffect(() => {
    if(testdata.sendingDoneLoading){
    }
  },[testdata.sendingDoneLoading]);

  useEffect(() => {
    if(isStartLoad) {
      dispatch(sendToNetwork(id));
    }
  }, [isStartLoad]);

  useEffect(() => {
    return () => {
      if(timeout.current){
        clearTimeout(timeout.current);
      }
    }
  },[]);

  const goBack = () => {
    navigate("/");
  }
  const retrySubmission = () => {
    setIsSuccess(!isSuccess);
  }
  const startLoad = () => {
    timeout.current = setTimeout(() => {
      setIsStartLoad(true);
    }, getRandomSeconds());
  }
  return (
      <>
        {testdata.sendingDoneLoading? (
            <div className="test-instructions-div">
              <div className="test-instructions-div col-md-12">
              <div className="test-body col-md-4 offset-md-4">
                <div className="col-md-10 offset-md-1 summary-body">
                  {!testdata.sendingError && (
                      <>
                        <div className="submit-query flexy flexyM">
                            <h3 className="col-md-5">Your answers were submitted</h3>
                            <button className="summary-btn  offset-md-4">
                              Your Score
                              <br />
                              {testdata.resultData?.result_data?.total_scored}/{testdata.resultData?.result_data?.total_mark}
                            </button>
                        </div>
                        <div className="flexy flexyM">
                          <div className="col-md-6">
                            <h6>Attempted Questions</h6>
                            <p>{testdata.resultData?.result_data?.questionAttended}</p>
                          </div>
                          <div className="">
                            <h6>Unattempted Questions</h6>
                            <p>{testdata.resultData?.result_data?.questionNotAttended}</p>
                          </div>
                        </div>
                        <div className="flexy flexyM">
                          <div className="col-md-6">
                            <h6>Incorrect Answers</h6>
                            <p>{testdata.resultData?.result_data?.total_incorrect}</p>
                          </div>
                          <div className="">
                            <h6>Unanswered Question</h6>
                            <p>{testdata.resultData?.result_data?.total_unanswered}</p>
                          </div>
                        </div>
                      </>
                  )}
                  {testdata.sendingError && (
                      <div className="flexy flexyM student-details text-error-test">
                        <div>
                          <p>{parse(testdata.sendingError)} {(testdata.sendingError && testdata.isRetry) && (
                              <button onClick={retrySubmission} className="return-analysis-btn mt3">Retry</button>
                          )}</p>

                        </div>
                      </div>
                  )}
                  <div style={{ borderTop:!testdata.sendingError? "solid 1px #e7e7e7":''}} className="mt4">
                    {" "}
                    <center>
                      {!testdata.sendingError && (<Link to={`/analysis-dashboard/${id}`}>
                        {" "}
                        <button className="return-analysis-btn mt3">Click to view Detailed Analysis</button>
                      </Link>)}
                      {" "}
                      <Link to={"/"}>
                        {" "}
                        <button className="return-btn mt3">Return to Main Windows</button>
                      </Link>
                    </center>
                  </div>
                </div>
              </div>
            </div>
            </div>
        ):(
          <LoadingGallery size={70} style={{ padding: '64px 32px', minHeight: '50vh' }} />
          )}
      </>
  );
};
